export default __webpack_public_path__ + "6838ea971a7ec9e6e0c718b430185ef6.png";